import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MotionConfig } from "motion/react";
import { App } from "./App.js";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("root element missing");

createRoot(container).render(
  <StrictMode>
    {/* `reducedMotion="user"` satisfies docs/REQUIREMENTS.md section 4 for
        every animation this library drives, in one line and for the whole
        tree. The CSS side is handled by the media query in styles.css; between
        them nothing animates for a reader who has asked it not to. */}
    <MotionConfig reducedMotion="user">
      <App />
    </MotionConfig>
  </StrictMode>,
);
